import './Progetto.css';
import ProgettoNav from './ProgettoNav';

function Progetto1() {
    return (
        <div className='progetto-container'>
            <ProgettoNav nextPath='/progetto-donna' />
            <h1 className='progetto-title'>LA VOCE DEI VOLONTARI NELLA COMUNITA'</h1>
            <p className='progetto-claim'>Comunicare Esperienze, condivisioni, cultura del Volontariato.</p>

            <h3>RELAZIONE ATTIVITA' 2021/2022</h3>
            <p>
                <strong>Il Progetto ha promosso il Volontariato</strong> in tutte le sue espressioni dando voce, attraverso Radio
                Cosmo e i social, ai Volontari delle Associazioni Socio Sanitarie locali.
            </p>
            <p>
                Lo scopo è stato quello di informare la cittadinanza sulle attività e servizi promossi dalle
                Associazioni di Volontariato con particolare attenzione ai giovani, ai temi della promozione
                e integrazione sociale.
            </p>
            <p>
                Si è data parola e visibilità ai Volontari e alle Associazioni ODV che operano nella Comunità.
                Si sono attivate alcune proposte rivolte ai giovani.
            </p>

            <p><strong><u>Si sono svolte le seguenti Azioni previste dal Programma:</u></strong></p>
            <p className='progetto-spacer'>
                <strong>Attivata su Radio COSMO la Rubrica settimanale "La Voce dei Volontari nella Comunità"</strong> che
                ha dato voce e visibilità alle iniziative e proposte dalle Associazioni attraverso le pagine
                social della Associazione Settemotivi - ODV e della web radio "Radio Cosmo".
            </p>
            <p>
                40 incontri con altrettante associazioni che hanno dato modo di mettere in rete e in sinergia
                informazioni, conoscenze, progetti, sviluppando nuovi contatti e nuove possibilità di lavoro
                in rete.
            </p>
            <p>
                La Voce dei Volontari nella Comunità è diventato una opportunità per costruire reti permanenti
                e collaborazioni che hanno continuità nel tempo.
            </p>
            <p>
                L'Iniziativa è stata molto apprezzata dalle Associazioni, dai loro Volontari e c'è stato un
                buonissimo ascolto. Inoltre le interviste / conversazioni saranno ritrasmette in radio nel
                corso del tempo.
            </p>
            <p>
                Sia 'Iniziativa La Voce dei Volontari nella Comunità e che ogni singolo incontro è stato
                promosso sui social con una specifica locandina. <strong><a href="https://www.radiocosmo.it/" target="_blank" rel="noreferrer"><u>www.radiocosmo.it</u></a> / FB radiocosmo / FB Settemotivi/Istagram</strong>
            </p>

            <p><strong>Realizzate° 40 interviste/conversazioni ad altrettante Associazioni di Volontariato dal 5 ottobre 2021 al 31 Marzo 2022:</strong></p>
            <ul>
                <li>Prendersi Cura Oncologiche, Nicola Delli Quadri, presidente</li>
                <li>In Prima Persona, Nicola Mannucci,presidente</li>
                <li>Casa del Volontariato di Pordenone, Sandra Conte, presidente</li>
                <li>Sorgente dei Sogni, Viviana Cadamuro, presidente</li>
                <li>Banca del Tempo Scambio, Marina Pedrotti, presidente</li>
                <li>Amici, Raffale Campagna, presidente</li>
                <li>Artsam,Savina Cappuzzello, presidente</li>
                <li>Gruppo Ama Ulisse, Mario D'Antin , facilitatore</li>
                <li>AIL, Stefano Boscariol, coordinatore</li>
                <li>Biblioteca di Sara,Cristina Savio, presidente</li>
                <li>Alzhaimer,Daniela Mannu, presidente</li>
                <li>LILT,Antnino Carbone, presidente</li>
                <li>Vip Claunando, Petro Polito, presidente</li>
                <li>AISLA, Elio Bailot, presidente</li>
                <li>ICTUS, Gianni Segalla, presiedente</li>
                <li>Noi Uniti per l'Autismo, Luca Apollonio, presidente</li>
                <li>Anziani San Valentino, Luciana Pennello, presidente, Bruno Bertin, vice</li>
                <li>Via di Natale, Carmen Gallini, direttrice</li>
                <li>AISM, Gabriele Cadelli, tesoriere e vice presidente regionale</li>
                <li>ANDOS, presidente, Marisa Zanella</li>
                <li>Laboratori Aitsamdd, Aurelia Pichilli, coordinatrice</li>
                <li>Studio Medico Solidale, Mirella Burel, coordinatrice</li>
                <li>Amici del Cuore,Rosa Maria Mannu, vice presidente</li>
                <li>AVO, Piera Gava, presidente</li>
                <li>Laudess Family, Loredana Colosimo, presidente</li>
                <li>AIFA, Giuseppe Frangapane, presidente</li>
                <li>Servizi Sociali Pordenone, Guglielmina Cucci, assessore</li>
                <li>CSV, Federico Coan, direttore</li>
                <li>AITSAM, Mauro Conti, presidente</li>
                <li>Centro Anziani Porcia, Giovanni Sanson , presidente</li>
                <li>Julia, Paola Costantini, presidente</li>
                <li>San Pietro Apostolo, Loris Paolo Rambaldini, presidente</li>
                <li>MOVI, Dino Del Savio, presidente regionale</li>
                <li>I Ragazzi della Panchina, Anna Moznich, presidente</li>
                <li>Voce Donna, Anna +++, coordinatrice</li>
                <li>Fondazione Down, Sandro Morassut, presidente</li>
                <li>Fondazione Credito Cooperativo, Paolo Rossi, Direttore</li>
                <li>Fondazione Welfare, Dino Del savio, direttore</li>
                <li>Associazione Down, Carmine Fago, vice presidente</li>
                <li>Gruppi AMA, Sandra Conte, coordinatrice</li>
                <li>Sportello Cohousing,Daniele Cipone, facilitatore</li>
            </ul>

            <p className='progetto-left progetto-marker'>&#x27A2; <strong>Promozione Ricerca e Formazione dei volontari</strong></p>
            <p>
                Si sono attivati 3 incontri on line e 3 in presenza nella sede con 6 Volontari che hanno
                collaborato nelle rubriche della radio. I Volontari sono stati formati a comprendere e
                utilizzare il linguaggio e le modalità di comunicazione in radio e nei social. Hanno gestito,
                con la collaborazione del Presidente le Rubriche della radio.
            </p>
            <div className='progetto-indent-block'>
                <p>
                    &#x27A2; <strong>Attivazione di gruppi social per giovani</strong>: si e attivato un gruppo di giovani studenti per la
                    gestione dei social della Associazione che collaborano in particolare su Istagram
                </p>
                <p>
                    &#x27A2; Con la collaborazione dei Volontari l'Associazione ha avviato rubriche radiofoniche che danno
                    voce alle varie forme culturali presenti nella Comunità
                </p>
                <ul className='progetto-indent'>
                    <li>
                        Si è promosso la conoscenza dei Cori della Regione come forma di espressione di appartenenza
                        e aggregazione di volontari che insieme offrono cultura e bellezza musicale. Collaborazione
                        con il Coro S. Antonio Abate di Cordenons.
                    </li>
                    <li>Avviata la Rubrica radiofonica Di Sana Salute gestita da volontario medico del lavoro Rosario Albanese</li>
                    <li>Avviata la rubrica radiofonica Racconti Brevi gestita da un gruppo di volontari lettori</li>
                    <li>Avviata la Rubrica Poesia e Pensiero con poeti e scrittori locali</li>
                </ul>
                <p>&#x27A2; <strong>Parla con me. Uno spazio radio dedicato a chi vuol uscire dall'isolamento del Covid .</strong></p>
                <p>Si è dato spazio attraverso la radio alle testimonianze dirette di chi ha vissuto il Covid.</p>

                <p className='progetto-left'>&#x27A2; <strong>Collaborazioni permanenti e future in progress</strong></p>
                <p>
                    La Radio della Associazione Settemotivi mette a disposizioni spazi per le rubriche settimanali
                    della Casa del Volontariato di Pordenone e dello Sportello Informativo Cohousing.
                </p>
                <p>
                    Si sono create collaborazioni e progetti associazioni socio sanitarie che si sono coinvolte nel
                    progetto dando così il modo, in progress, di dare continuità alla Voce dei Volontari nella Comunità.
                </p>
            </div>
            <ProgettoNav nextPath='/progetto-donna' />
        </div>
    );
}

export default Progetto1;
